import React from 'react';
import { SectionHeader, SectionTitleProps } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

interface SectionHeaderBlockProps extends SectionTitleProps {
  attrs?: any;
}

export const SectionHeaderBlock: React.FC<SectionHeaderBlockProps> = ({ attrs }) => {
  // TODO: FIX THE PROPERTY NAMES
  const title = attrs?.data?.title ?? attrs?.data?.section_block_header_title;
  const subtitle = attrs?.data?.subtitle ?? attrs?.data?.section_block_header_subtitle;
  const bordered = Boolean(attrs?.data?.bordered) ?? Boolean(attrs?.data?.section_block_header_title);
  const level = Number(attrs?.data?.level) || Number(attrs?.data?.section_block_header_level) || 2;
  const subtitleTinted = attrs?.data?.subtitle_tinted ?? attrs?.data?.section_block_header_subtitle_tinted;

  if (!title) return <div />;

  return (
    <Container className="section-block-header">
      <SectionHeader
        bordered={bordered}
        level={level}
        subtitle={subtitle}
        subtitleTinted={subtitleTinted}
        title={title}
      />
    </Container>
  );
};

const Container = styled.div`
  &.section-block-header {
    display: block;
    margin-bottom: 1rem;

    .subtitle {
      font-size: ${({ theme }) => theme.fontSize.lg};
    }
  }
`;
